/** @jsx jsx */
import React from "react"
import { Heading, jsx } from "theme-ui"

import { Box } from "@shared-components/Box/Box"
import { ButtonLink } from "@shared-components/Button/Button"
import { BackgroundVideo } from "@shared-components/BackgroundVideo/BackgroundVideo"
import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio"
import { headingStyles, linkCTAStyle } from "./styles"
import { MediaModule } from "src/carlsberg-headless/types/modules/Media"
import { LinkField } from "src/carlsberg-headless/types/fields/Link"
import { Container } from "@shared-components/Container/Container"
import { UmbracoBackgroundImage } from "@shared-components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage"
import { TAXONOMIES_MAP } from "../../carlsberg-headless/taxonomies-map"

const CTA: React.FC<LinkField> = props => (
  <ButtonLink
    to={props.url}
    {...(props.target && { target: props.target })}
    variant="whiteOutline"
    outline
  >
    {props.name}
  </ButtonLink>
)

export type MediaModuleProps = MediaModule

const Media: React.FC<MediaModuleProps> = ({
  video,
  link,
  image,
  cbKey,
  taxonomies,
}) => {
  const isBottleCollection = taxonomies?.includes(
    TAXONOMIES_MAP.media_module.bottle_collection
  )
  return (
    <Container key={cbKey} withoutPaddingInline={isBottleCollection}>
      <Box>
        <AspectRatio ratio={["335:455", "16:9"]}>
          {video && video.fullUrl && (
            <BackgroundVideo src={video.fullUrl}>
              {link && <CTA {...link} />}
            </BackgroundVideo>
          )}
          {!video && image && image.fullUrl && (
            <UmbracoBackgroundImage image={image}>
              <Box sx={linkCTAStyle}>
                {isBottleCollection && (
                  <Heading as={"h2"} sx={headingStyles}>
                    {image.altText}
                  </Heading>
                )}
                {link && <CTA {...link} />}
              </Box>
            </UmbracoBackgroundImage>
          )}
        </AspectRatio>
      </Box>
    </Container>
  )
}

export { Media }
